
export default () => (
  <>
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      재단 설립 목적과 비전
    </h2>
    <div className="cs-bid_info">
      <div className="min-titlef">기후 변화 대응, 더 이상 선택이 아닌 필수</div>
      <div style={{ textAlign: "start" }}>
        기후 문제는 인류가 직면한 가장 심각한 도전 과제입니다. 기후가 변화한다는 관망자적 관점에서 이제는 기후가 재난을 일으킨다는 적극적 인식과 실천이 필요한 때입니다. 인류의 넷제로 선언은 기후종말 도래시기를 지연시킬뿐 문제 해결을 위한 근본적인 수단이 되지 못합니다. 넷제로를 넘어 카본네거티브를 통해 대기 중 온실가스 농도를 산업혁명 이전만큼 낮춰야 합니다.
        <br />
        이제, 우리는 단순한 환경 보호를 넘어 지속 가능한 미래를 위한 근본적인 변화를 만들어야 합니다.
        <br />
        기후재단은 이러한 시대적 요구에 부응하여 탄소 감축 및 탄소크래딧 거래의 새로운 패러다임을 제시하고자 설립되었습니다.
        <br />
        ‘대기 온실가스 농도를 낮추자’ 이는 기후재단이 추구하는 명확한 방향성입니다. 현재의 자발적 탄소크레딧 시장은 불명확한 MRV, 불투명한 인증 절차, 신뢰할 수 없는 감축 효과, 복잡한 거래 구조와 같은 문제가 상존해 있습니다.
        <br />
        기후재단은 이러한 문제를 해결하고, 보다 신뢰할 수 있는 자발적 탄소크레딧 인증과 거래 시스템을 구축하기 위해 탄생했습니다.
        <br />
        우리는 탄소 감축 프로젝트의 과학적 인증 절차와 명확한 MRV 시스템을 통해 신뢰성을 확보하고, 쉽고 투명한 거래 환경을 조성하며, 미래를 위한 지속 가능한 탄소 감축 생태계를 구축하는 것을 목표로 하여 개인부터 단체, 법인, 더 나아가서는 국가까지 모두 카본네거티브에 기여할 수 있는 발판을 마련할 것입니다.
      </div>
    </div>


    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      지속 가능한 미래를 위한 기후재단의 역할
    </h2>
    <div className="cs-bid_info">
      <div className="text-center">
        우리는 단순히 탄소 크레딧을 거래하는 플랫폼이 아닙니다.<br />
        우리는 기후 위기에 대응하는 새로운 기준을 만들고, 보다 지속 가능하고 공정한 탄소 크레딧 시장을 구축하는 것을 목표로 합니다.
      </div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>신뢰할 수 있는 탄소크레딧 인증 시스템을 통해 기업과 개인이 안심하고 탄소 감축에 참여할 수 있도록 합니다.</li>
          <li>블록체인을 활용한 투명한 거래 환경을 조성하여, 탄소크레딧의 전주기 신뢰를 높입니다.</li>
          <li>누구나 쉽게 탄소중립에 기여할 수 있는 접근성을 확보하여, 기후 위기 대응을 대중화합니다.</li>
        </ul>
      </div>
      <div className="text-center">
        기후재단은 카본네거티브를 위한 가장 고품질의 탄소크레딧 인증 기관으로 지속 가능한 미래를 위한 핵심 역할을 수행할 것입니다.<br />
        탄소중립은 거창한 목표가 아닙니다. 이제, 누구나 쉽게 실천할 수 있는 현실적인 해결책이 될 것입니다.<br />
        기후재단과 함께 더 나은 미래를 만들어 갈 여러분을 초대합니다. 우리는 탄소중립을 위한 새로운 길을 열고 있습니다.<br />지속 가능한 미래를 함께 만들어갑시다!
      </div>
    </div >
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      기후재단이 만드는 새로운 탄소 크레딧 시장
    </h2>

    <div className="cs-bid_info">
      <div className="min-titlef">01 까다로운 인증, 완벽한 신뢰성</div>
      <div className="text-center">
        현재 탄소 크레딧 시장에서는 프로젝트의 신뢰성을 입증하기 어려운 경우가 많아 시장 형성을 방해하고 있습니다.<br />
        실제 감축 효과가 없는 프로젝트를 통해 탄소 크레딧을 발행하거나, 허위 감축량을 보고하는 방식으로 시장을 왜곡하고 있습니다.<br />
        기후재단은 탄소 감축 프로젝트의 신뢰성을 보장하기 위한 인증 절차를 운영합니다.<br />
      </div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>다단계 심사 프로세스</label> : 프로젝트가 등록되면, 해당 프로젝트의 방법론과 예상 감축 효과를 분석하고, 이후 감축 성과를 검증합니다.</li>
          <li><label>심의 기준 :</label> 기후재단의 인증 프로세스는 8가지 심의기준 토대로 더욱 강화된 자체 심사 기준을 적용합니다.</li>
          <li><label>데이터 기반 검증</label> : 과거 감축 성과를 검토하고, 독립적인 제3자 기관의 검증을 거쳐 탄소크레딧 발행의 신뢰성을 극대화합니다.</li>
          <li><label>지속적인 모니터링 :</label> 단순히 발행 과정에서만 인증하는 것이 아니라, 감축 효과가 유지되고 있는지 정기적으로 모니터링하여 신뢰할 수 있는 MRV 시스템을 구축합니다.</li>
        </ul>
      </div>
      <div className="text-center">
        기후재단의 인증 절차를 통과한 크레딧은 정확한 감축 효과가 입증된 신뢰할 수 있는 크레딧이며,<br />
        이를 통해 기업과 개인이 안심하고 탄소 감축 활동에 참여할 수 있도록 합니다.
      </div>
      <div className="min-titlef">02 블록체인 기술을 활용한 투명한 거래</div>
      <div className="text-center">
        탄소 크레딧 거래 시장에서는 중복 사용(Double Counting) 문제, 거래 기록의 불투명성, 시장의 신뢰 부족 등의 문제가
        지속적으로 발생하고 있습니다. 기후재단은 블록체인 기술을 기반으로 탄소 크레딧의 추적성과 신뢰성을 보장합니다.      </div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>
            <label>모든 거래의 실시간 공개 : </label>
            탄소 크레딧의 발행, 판매, 사용 과정이 블록체인에 기록되며, 모든 참여자가 이를 확인할 수 있습니다.
          </li>
          <li>
            <label>이중 사용 방지 :</label>
            블록체인 기반의 스마트 컨트랙트(Smart Contract) 시스템을 도입하여, 한 번 사용된 탄소 크레딧이 다시 거래 되지 않도록 보장합니다.
          </li>
          <li>
            <label>투명한 검증 시스템:</label>
            탄소 크레딧의 감축 효과와 거래 내역이 변조될 수 없도록 보장하여, 기업과 개인이 신뢰할 수 있는 시장 환경을 제공합니다.
          </li>
        </ul>
      </div>
      <div className="text-center">
        이러한 기술적 접근 방식을 통해, 기후재단은 탄소 크레딧 시장의 불신을 해소하고, 누구나 믿을 수 있는 거래 환경을 조성합니다.
      </div>
      <div className="min-titlef">03 누구나 쉽게 참여할 수 있는 플랫폼</div>
      <div className="text-center">
        탄소 크레딧 시장은 현재 일반 소비자가 접근하기 어렵고, 기업들조차도 거래 절차가 복잡하여 참여가 쉽지 않습니다.<br />
        기후재단은 기업과 개인 모두가 손쉽게 탄소 감축 활동에 참여할 수 있도록 직관적인 플랫폼을 제공합니다.
      </div>

      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>
            <label>사용자 친화적인 인터페이스: </label>
            복잡한 절차 없이, 몇 번의 클릭만으로 탄소 크레딧을 구매하거나 거래할 수 있도록 플랫폼을 설계합니다.
          </li>
          <li>
            <label>기업 맞춤형 솔루션 제공:</label>
            기업이 자체적인 탄소중립 목표를 설정하고 이를 달성할 수 있도록 맞춤형 감축 전략을 제공합니다.
          </li>
          <li>
            <label>개인도 쉽게 탄소 감축에 기여 :</label>
            기업뿐만 아니라 일반 소비자도 탄소 크레딧을 구매하여 자신의 탄소 발자국을 줄일 수 있도록 지원합니다.
          </li>
        </ul>
      </div>
    </div>


    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      기후재단 이사장 인사말
    </h2>
    <div className="cs-bid_info">
      <div className="min-titlef">
        "탄소중립을 위한 새로운 기준을 만들겠습니다."
      </div>
      <div className="text-center">
        존경하는 여러분,<br />
        기후 변화는 더 이상 미래의 문제가 아니라, 지금 우리가 해결해야 할 현실적인 도전 과제입니다.
        탄소 배출 감축과 탄소중립 실현을 위한 다양한 노력이 이루어지고 있지만, 현재의 탄소 크레딧 시장은 불투명한 인증 절차, 신뢰성 부족, 중복 산정 문제 등으로 인해 많은 한계를 가지고 있습니다.<br />
        기후재단은 탄소 크레딧 시장의 이러한 문제를 해결하고, 투명하고 신뢰할 수 있는 인증 및 거래 시스템을 구축하기 위해 설립되었습니다. 우리는 엄격한 인증 절차, 블록체인 기반의 투명한 데이터 관리, 누구나 쉽게 참여할 수 있는 거래 환경을 제공하여 탄소 감축을 보다 효과적으로 실현할 수 있도록 지원하겠습니다.
      </div>
      <div className="min-titlef">기후재단의 역할과 목표</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>
            <b>신뢰할 수 있는 탄소 크레딧 인증</b><br />
            과학적 데이터와 정량적 분석을 기반으로 탄소 감축 효과를 검증<br />
            글로벌 기준을 준수하는 엄격한 인증 절차 운영
          </li>
          <li>
            <b>투명한 탄소 크레딧 거래 환경 조성</b><br />
            블록체인 기반의 데이터 기록으로 거래 내역 조작 및 중복 사용 방지<br />
            누구나 거래 내역을 확인할 수 있는 완전한 투명성 제공
          </li>
          <li>
            <b>누구나 쉽게 참여할 수 있는 탄소중립 시스템</b><br />
            개인과 기업이 탄소 크레딧을 쉽게 구매 및 활용할 수 있도록 간소화된 플랫폼 제공<br />
            대기업뿐만 아니라 중소기업과 개인도 탄소중립에 기여할 수 있도록 지원
          </li>
        </ul>
      </div>
      <div className="min-titlef">미래를 향한 우리의 다짐</div>
      <div className="agreement-panel">
        <div className="min-titlef">"우리는 신뢰할 수 있는 탄소 크레딧 시장을 만들어,
          지속 가능한 미래를 열겠습니다."</div>
        <div className="text-center">
          지속 가능한 미래를 위한 변화는 단순한 선언이 아니라, 실질적인 감축 효과를 창출하고 이를 공정하게 평가할 수 있는 체계가 구축될 때 가능해집니다. <br />
          기후재단은 탄소중립을 위한 새로운 기준을 만들고, 탄소 감축 활동이 실질적인 가치로 연결될 수 있도록 최선을 다하겠습니다.<br />
          탄소중립은 이제 선택이 아닌 필수입니다. <br />
          기후재단과 함께 지속 가능한 미래를 만들어 갑시다.<br />
          감사합니다.<br />
        </div>
        <div className="min-titlef">
          기후재단 이사장
        </div>
      </div>
    </div>

    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      기후재단 이사 인사말
    </h2>
    <div className="cs-bid_info">
      <div className="min-titlef">안녕하세요. 기후재단 이사 강신걸입니다.</div>
      <div className="text-center">
        우리는 지금, 전 세계적으로 기후 위기가 점점 심화되고 있는 현실 속에서 살아가고 있습니다. 탄소중립은 이제 거스를 수 없는 시대적 과제가 되었으며, 지속 가능한 미래를 위해 개인과 기업, 그리고 사회 전체가 함께 고민하고 실천해야 하는 중요한 목표입니다. 기후재단은 이러한 변화를 주도하며, 보다 실질적이고 효과적인 탄소 감축과 지속 가능한 환경 조성을 위해 설립되었습니다.
      </div>
      <div className="text-center">
        저는 사업 전문성을 바탕으로 기후재단이 탄소 감축 프로젝트를 보다 체계적으로 운영하고, 신뢰성과 투명성을 갖춘 지속 가능한 모델로 자리 잡을 수 있도록 하는 데 최선을 다하고 있습니다. 단순히 기후 문제를 논의하는 것을 넘어, 실질적인 솔루션을 개발하고, 기업과 개인이 쉽게 참여할 수 있는 구조를 마련하는 것이 저의 핵심 역할입니다.      </div>
      <div className="text-center">
        기후재단은 탄소 크레딧 거래와 감축 프로젝트를 보다 신뢰할 수 있고 효과적으로 운영할 수 있는 플랫폼을 구축하고 있으며, 이를 통해 탄소중립을 실천하는 기업과 개인이 원활하게 참여할 수 있도록 지원하고 있습니다. 이를 위해 탄소 크레딧 인증을 기반으로 한 시장 구조를 마련하고, 탄소 크레딧이 보다 효율적으로 유통될 수 있는 환경을 조성하는 것이 중요한 과제입니다.      </div>
      <div className="text-center">
        우리 재단이 운영하는 플랫폼은 단순한 거래 시스템이 아닙니다. 탄소 감축이 효과적으로 이루어지고, 투자자와 기업이 신뢰할 수 있는 환경을 조성하기 위한 핵심 도구입니다. 이를 위해 탄소 크레딧의 발행과 검증을 보다 명확하게 하고, 프로젝트의 신뢰도를 높이는 방향으로 사업을 운영하고 있습니다.      </div>
      <div className="text-center">
        저는 이러한 과정에서 재단이 전문성과 책임감을 바탕으로 올바르게 운영될 수 있도록, 전략을 수립하고 실행하는 데 중점을 두고 있습니다. 탄소중립을 위한 노력이 단순한 선언에 그치지 않고, 실질적인 결과로 이어질 수 있도록 기후재단이 시장의 신뢰를 얻고, 효과적인 감축 프로젝트를 운영할 수 있도록 더욱더 철저하게 관리하고 이끌어 나가겠습니다.      </div>
      <div className="text-center">
        우리의 목표는 단순한 탄소 크레딧 거래 시장을 만드는 것이 아니라, 더 많은 사람들이 탄소 감축에 직접적으로 기여하고, 기업이 적극적으로 탄소중립을 실천할 수 있도록 돕는 것입니다. 이를 위해 기후재단은 보다 투명하고, 체계적이며, 지속 가능한 방향으로 사업을 운영해 나갈 것입니다.      </div>
      <div className="text-center">
        앞으로도 기후재단의 활동에 많은 관심과 참여를 부탁드립니다. 우리는 함께 탄소중립을 실현할 수 있습니다.<br />우리의 노력 하나하나가 모여 더 나은 미래를 만들어 갈 것입니다.      </div>
      <div className="text-center">감사합니다.</div>
      <div>
        <b>
          기후재단 이사, 강신걸
        </b>
      </div>
    </div>

  </>
);